import type { Resource } from '../../';
export const general_errors_renderAlerts_timestampTooltip: Resource = {"default":"The time elapsed since the page loaded when the error occurred."};
